import {
  isSimpleOrConfigurationOnlyFieldValueField,
  isSubTemplatedField,
  isTemplateReferenceValueSetupField,
  type TemplateField,
  ValueSetupRole,
} from '../../types/templateModel'
import { SimpleFieldValue } from '../simpleFieldValue/SimpleFieldValue'
import { TemplateReferenceFieldValue } from '../templateReference/TemplateReferenceFieldValue'
import { SubTemplatedFieldValueDefaultSelected } from './SubTemplatedFieldValueDefaultSelected'

type Props = {
  field: TemplateField
}

export const TemplateFieldValue = ({ field }: Props) => {
  if (isSimpleOrConfigurationOnlyFieldValueField(field)) {
    return <SimpleFieldValue field={field} />
  } else if (isTemplateReferenceValueSetupField(field)) {
    return <TemplateReferenceFieldValue field={field} />
  } else if (
    isSubTemplatedField(field) &&
    field.role === ValueSetupRole.SINGLE_CLASS_SUB_TEMPLATE &&
    !!field.value?.variants.at(0)
  ) {
    return (
      <SubTemplatedFieldValueDefaultSelected
        variant={field.value.variants.at(0)!}
      />
    )
  }

  return null
}
